import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import validator from 'validator';
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Modal,
  Typography,
  Radio,
  Select,
  Alert,
  Result
} from 'antd';
import {
  SaveOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  IdcardOutlined,
  BookOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';

import { descobrirContrato } from '../actions/ContratoActions';
import { consultarTurmas } from '../actions/TurmaActions';
import { obterFormandosPeloContrato, editarFormandoEASAAS } from '../actions/FormandoActions';
import { toast } from 'react-toastify';

const { Title, Text } = Typography;
const { Option } = Select;

class MeusDados extends React.Component {

  state = {
    showModalCursoNaoCadastrado: false,
    formando: {
      id: "",
      nome: "",
      email: "",
      celular: "",
      documento: "",
      turma: null
    },
    turmasSelect: [],
    tipoPessoa: ""
  }

  async componentWillMount () {
    await this.props.descobrirContrato(this.props.usuario.tipo, this.props.usuario.tipo === "formando" ? this.props.numeroContrato : this.props.usuario.id).then(async () => {
      if (this.props.contrato.turmas && this.props.contrato.turmas.length > 0) {
        let turmas = [];
        await this.carregarDadosFormando();
        this.props.contrato.turmas.forEach((turma) => { turmas.push({value: turma.id, label: turma.curso}) });
        this.setState({turmasSelect: turmas});
      } else {
        this.setState({showModalCursoNaoCadastrado: true});
      }   
    });
  }

  async carregarDadosFormando () {
    await this.props.obterFormandosPeloContrato(this.props.contrato.id);

    let formando = this.props.formandos.filter((formando) => { return formando.usuario && formando.usuario.id === this.props.usuario.id})[0],
      turmaSelecionada = this.props.contrato.turmas.filter((turma) => {return turma.id === formando.turma})[0];

    formando = { 
      id: formando.id,
      nome: formando.nome,
      email: formando.email,
      documento: formando.documento,
      celular: formando.celular,
      turma: { value: turmaSelecionada.id, label: turmaSelecionada.curso } 
    };

    const documentoNumerico = String(formando.documento || "").replace(/\D/g, "");

    this.setState({ formando, tipoPessoa: documentoNumerico.length === 14 ? "juridica" : "fisica" });
  }

  handleChangeUsuario (e) {
    const { name, value } = e.target;
    this.setState({formando: {...this.state.formando, [name]: value}});
  }
  
  handleChangeTurma (turmaSelecionada) {
    this.setState({formando: {...this.state.formando, turma: turmaSelecionada}});
  }

  async handleSubmitUsuario (e) {
    e.preventDefault();
    this.setState({salvando: false});

    let formando = Object.assign({}, this.state.formando),
      validadorDocumento = require("br-doc-validator");

    formando.documento = String(formando.documento || "").replace(/\D/g, "");

    await validadorDocumento.documentValidatorProm(formando.documento).then(() => {
      if (validator.isEmail(formando.email)) {
        formando.turma = formando.turma.value;
        formando.celular = Number(String(formando.celular).replace(/[()-.+\s]/g, ""))
        this.props.editarFormandoEASAAS(formando, this.props.contrato.numero);
        toast.success("Formando alterado com sucesso!");
        this.props.history.push("./");
        this.setState({salvando: false}); 
      } else {
        toast.error("O e-mail inserido é inválido!");
      }
    }, () => {
      toast.error("O documento inserido é inválido!");
    });
  }

  render () {
    if (this.props.usuario.tipo === "comissao") {
      return <Redirect to="./"/>;
    }

    const { formando, tipoPessoa, turmasSelect, salvando } = this.state;

    return (
      <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
        <Card
          bordered={false}
          style={{ boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: '8px' }}
        >
          <div style={{ marginBottom: 24 }}>
            <Title level={2}>
              <UserOutlined style={{ marginRight: 8, color: '#dc2626' }} />
              Meus Dados
            </Title>
            <Text type="secondary">Atualize suas informações pessoais e de contato.</Text>
          </div>

          <Alert
            message="Informações Importantes"
            description="Certifique-se de que todos os dados estão corretos, pois eles serão utilizados para a emissão de documentos e entregas."
            type="info"
            showIcon
            icon={<InfoCircleOutlined />}
            style={{ marginBottom: 24, borderRadius: '8px' }}
          />

          <form onSubmit={this.handleSubmitUsuario.bind(this)} onChange={this.handleChangeUsuario.bind(this)}>
            <Form layout="vertical">
              {/* Tipo de Pessoa */}
              <Form.Item label="Tipo de Cadastro" required>
                <Radio.Group
                  value={tipoPessoa}
                  onChange={(e) => this.setState({
                    tipoPessoa: e.target.value,
                    formando: { ...this.state.formando, documento: "" }
                  })}
                  size="large"
                >
                  <Radio.Button value="fisica">Pessoa Física</Radio.Button>
                  <Radio.Button value="juridica">Pessoa Jurídica</Radio.Button>
                </Radio.Group>
              </Form.Item>

              <Row gutter={16}>
                {/* Nome Completo */}
                <Col xs={24} md={24}>
                  <Form.Item label="Nome Completo" required>
                    <Input
                      prefix={<UserOutlined style={{ color: '#999' }} />}
                      name="nome"
                      value={formando.nome}
                      size="large"
                      placeholder="Digite seu nome completo"
                      required
                    />
                  </Form.Item>
                </Col>

                {/* Documento */}
                <Col xs={24} md={12}>
                  <Form.Item label={tipoPessoa === "fisica" ? "CPF" : "CNPJ"} required>
                    <InputMask
                      key={tipoPessoa}
                      mask={tipoPessoa === "fisica" ? "999.999.999-99" : "99.999.999/9999-99"}
                      value={formando.documento}
                      className="ant-input ant-input-lg"
                      name="documento"
                      placeholder={tipoPessoa === "fisica" ? "999.999.999-99" : "99.999.999/9999-99"}
                      required
                      style={{
                        width: '100%',
                        paddingLeft: '32px',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z'/%3E%3C/svg%3E")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '8px center',
                        backgroundSize: '16px 16px'
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Email */}
                <Col xs={24} md={12}>
                  <Form.Item label="E-mail" required>
                    <Input
                      prefix={<MailOutlined style={{ color: '#999' }} />}
                      type="email"
                      name="email"
                      value={formando.email}
                      size="large"
                      placeholder="seu@email.com"
                      required
                    />
                  </Form.Item>
                </Col>

                {/* Celular */}
                <Col xs={24} md={12}>
                  <Form.Item label="Celular" required>
                    <InputMask
                      mask="(99) 9 9999-9999"
                      value={formando.celular}
                      className="ant-input ant-input-lg"
                      name="celular"
                      placeholder="(99) 9 9999-9999"
                      required
                      style={{
                        width: '100%',
                        paddingLeft: '32px',
                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z'/%3E%3C/svg%3E")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '8px center',
                        backgroundSize: '16px 16px'
                      }}
                    />
                  </Form.Item>
                </Col>

                {/* Curso */}
                <Col xs={24} md={12}>
                  <Form.Item label="Curso" required>
                    <Select
                      size="large"
                      placeholder="Selecione seu curso"
                      value={formando.turma ? formando.turma.value : undefined}
                      onChange={(value) => {
                        const turmaSelecionada = turmasSelect.find(t => t.value === value);
                        this.handleChangeTurma(turmaSelecionada);
                      }}
                      suffixIcon={<BookOutlined />}
                      style={{ width: '100%' }}
                    >
                      {turmasSelect.map((turma) => (
                        <Option key={turma.value} value={turma.value}>
                          {turma.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* Botão de Salvar */}
              <div style={{ marginTop: 24, textAlign: 'right' }}>
                <Button
                  type="primary"
                  danger
                  size="large"
                  icon={<SaveOutlined />}
                  loading={salvando}
                  htmlType="submit"
                  style={{ minWidth: '200px', height: '50px', fontSize: '16px', borderRadius: '6px' }}
                >
                  Atualizar Dados
                </Button>
              </div>
            </Form>
          </form>
        </Card>

        {/* Modal Curso Não Cadastrado */}
        <Modal
          visible={this.state.showModalCursoNaoCadastrado}
          onCancel={() => this.setState({ showModalCursoNaoCadastrado: false })}
          footer={null}
          centered
          width={600}
        >
          <Result
            status="warning"
            title="Curso não encontrado"
            subTitle="Para atualizar suas informações é necessário que o seu curso esteja cadastrado no sistema. Por favor, solicite ao seu atendente que faça o cadastro."
            extra={[
              <a key="voltar" href="./">
                <Button type="primary" size="large">
                  Voltar
                </Button>
              </a>
            ]}
          />
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    turmas: state.turmas.turmas,
    numeroContrato: state.usuario.numeroContrato
  }
}

export default connect(mapStateToProps, { consultarTurmas, editarFormandoEASAAS, obterFormandosPeloContrato, descobrirContrato })(MeusDados);
